import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { BulkActionPayload, BulkActionActions, BulkActionType } from '../reducers/BulkActionReducer';
import ComponentName from '../../constant/ComponentName';
import { ComponentDependency } from 'domain/ui/ComponentMetadata';

export interface DependencyResponse {
  id: string;
  status: boolean;
  reason: 'DELETE' | 'UNDEPLOY' | 'DEPLOYED' | undefined;
  dependencies: ComponentDependency[];
}

export const openBulkActionDialog = (payload: BulkActionPayload) =>
  ({
    type: 'OPEN_BULK_ACTION_DIALOG',
    payload,
  }) as ReduxBaseAction<BulkActionPayload, BulkActionActions>;

export const closeBulkActionDialog = () =>
  ({
    type: 'CLOSE_BULK_ACTION_DIALOG',
  }) as ReduxBaseAction<null, BulkActionActions>;

export const setBulkAction = (payload: BulkActionPayload) =>
  ({
    type: 'SET_BULK_ACTION',
    payload,
  }) as ReduxBaseAction<BulkActionPayload, BulkActionActions>;

export const openBulkActionDialogFromDependency = (dependencyResponse: DependencyResponse | DependencyResponse[], componentName: ComponentName) => {
  const dependencies = Array.isArray(dependencyResponse) ? dependencyResponse : [dependencyResponse];
  const firstDep = dependencies[0];
  let actionType: BulkActionType = 'REMOVE';
  if (firstDep.reason === 'UNDEPLOY') {
    actionType = 'UNDEPLOY';
  } else if (firstDep.reason === 'DEPLOYED') {
    actionType = 'DEPLOY';
  } else {
    actionType = 'REMOVE';
  }

  const dependencyErrors = dependencies.map((dep) => ({
    id: dep.id,
    dependencies: (dep.dependencies || []).map((d) => ({
      componentType: d.componentType,
      componentId: d.componentId,
    })),
  }));

  return openBulkActionDialog({
    actionType,
    componentName,
    selectedStatuses: [],
    hasMixedStatuses: false,
    dependencyErrors,
    onConfirm: () => {},
  });
};
